import { render, staticRenderFns } from "./audioplayer.vue?vue&type=template&id=c6a26d34&"
import script from "./audioplayer.vue?vue&type=script&lang=js&"
export * from "./audioplayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports